import { Button } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import { Form, Formik } from "formik";
import { useHistory } from "react-router";
import * as yup from "yup";
import LabelsContext from "../../../lang/LabelsContext";
import PublicService, { PublicServiceType } from "../../../service/public/PublicService";
import Images from "../../../utils/Images";
import ResetPassword from "../reset-password/ResetPassword";
import useStyles from "./LoginStyle";
import Password from "../../system/password/Password";

const validationSchema = yup.object().shape({
  email: yup.string().required().email(),
  password: yup.string().required(),
});

function Login() {
  const classes = useStyles();

  const { Labels } = LabelsContext();

  const history = useHistory();

  const { login, resetDialog, openResetDialog, closeResetDialog }: PublicServiceType = PublicService();

  return (
    <>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <img src={Images.LOGO} className={classes.logo} alt="logo" />
          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            validationSchema={validationSchema}
            onSubmit={login}
          >
            {({ handleBlur, values, touched, errors, handleChange, setFieldValue }) => (
              <Form>
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="email"
                  label={Labels.EMAIL}
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                />
                <Password
                  label={Labels.PASSWORD}
                  name="password"
                  statePassword={values.password}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  touchedPassword={touched.password}
                  errorsPassword={errors.password}
                />
                <Button fullWidth variant="text" color="primary" onClick={openResetDialog}>
                  {Labels.FORGOT_PASSWORD}
                </Button>
                <div className={classes.containerButton}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="primary"
                    className={classes.submit}
                    onClick={() => history.push("/registration")}
                  >
                    {Labels.REGISTRATION}
                  </Button>
                  <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
                    {Labels.LOGIN}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <ResetPassword open={resetDialog} handleClose={closeResetDialog} />
      </Container>
    </>
  );
}

export default Login;
